import React from 'react';

export const ProjectCard = ({ title, language, imgUrl, description, demoLogin, live, source, reverse }) => {

  return (
    <article className={`project-feature ${reverse ? 'project-feature--reverse' : ''}`}>
      <div className="project-media">
        <img src={imgUrl} alt={title} />
      </div>
      <div className="project-content">
        <span className="project-kicker">Featured Project</span>
        <h4 className="p-title">{title}</h4>
        <p>{description}</p>
        <ul>
          {language.map((l, index) => {
            return (<li key={index}>{l}</li>)
          })}
        </ul>
        {demoLogin && (
          <div className="demo-login">
            <h5>Demo Admin Account</h5>
            <div className="demo-login-grid">
              <span>Role</span>
              <strong>{demoLogin.role}</strong>
              <span>Email</span>
              <strong>{demoLogin.email}</strong>
              <span>Password</span>
              <strong>{demoLogin.password}</strong>
            </div>
            <p>{demoLogin.note}</p>
          </div>
        )}
        <div className="project-actions">
          <a className="fluffy-button" href={live} target="_blank" rel="noreferrer">Live</a>
          <a className="fluffy-button fluffy-button--secondary" href={source} target="_blank" rel="noreferrer">Source</a>
        </div>
      </div>
    </article>
  )
}

export default ProjectCard;
